import React from 'react'
// import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components
import SolutionItem from './components/SolutionItem'

// Lib MISC
import solutionData from '@/constants/solutionData'
import styles from './style.scss'
import words from "@/assets/worddict.json"

const cx = classnames.bind(styles)

export const propTypes = {}

function Solution ({ lang }) {
  const $t = words[lang]

  const solution = solutionData($t)

  return (
    <div className={cx('solution')}>
      <div className={cx('solution-wrap')}>
        <div className={cx('solution-wrap__info')}>
          <p className={cx('solution-wrap__info-type')}>{$t.TXT_Solution_title}</p>
          <p className={cx('solution-wrap__info-title')}>{$t.TXT_Solution_subtitle}</p>
          <p className={cx('solution-wrap__info-description')}>{$t.TXT_Solution_description}</p>
        </div>
        <div className={cx('solution-wrap__list')}>
          {solution.map((item, index) => (
            <SolutionItem key={index} index={index} {...item} />
          ))}
        </div>
      </div>
    </div>
  )
}

Solution.propTypes = propTypes

export default Solution
